module.exports = __webpack_public_path__ + "img/kitchen.12f17f14.jpg";